import React, { useState, useEffect, useRef } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { URLS } from '../../_config';
import Icon from '../../components/icons';
import { useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { useDataSourceApi } from '../../store/api/hooks/dataSourceApiHook';
import { toast } from 'react-hot-toast';
import Spinner from "../../components/iconSvgs/spinner";
import Header from '../../components/header';
import ThirdPartyDatabase from './thirdPartyDatabase';
import InternalDatabase from './internalDatabase';
import { usePusherDataSelector } from '../../store/selectors/pusherSelector';
import { PusherResponse } from '../../_config/interfaces/interfaces';

const Settings: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState('third_party');
    const [isSettingLoading, setIsSettingLoading] = useState<boolean>(false);
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const isAddBtnDisabled = useRef<boolean>(false);

    const branchDS = useStoreBrnDSSelector();
    const dataSourceAPI = useDataSourceApi();
    const navigate = useNavigate();
    const pusherData = usePusherDataSelector();

    const [inputGroups, setInputGroups] = useState([
        { id: 1, source: '', url: '' },
    ]);

    const addInputGroup = () => {
        setInputGroups([
            ...inputGroups,
            { id: inputGroups.length + 1, source: '', url: '' }
        ]);
    };

    const handleSubmit = () => {
        // console.log('inputGroups =>', inputGroups);
        setOnSubmitLoading(true);
        const param = {
            store_id: branchDS?.store_id,
            branch_id: branchDS?.branch_id,
            source_type: inputGroups[0].source,
            url: inputGroups[0].url
        }

        setTimeout(() => {
            dataSourceAPI.addExternalDataSource(param, (msg: any, resp: any) => {
                // console.log('response =>', resp);
                if (resp?.code === 201 || resp?.code === 200) {
                    toast.success(resp?.message);
                    navigate(URLS.DATASOURCES.LIST);
                    // navigate(URLS.DASHBOARD);
                } else {
                    toast.error(resp?.message);
                }
                setOnSubmitLoading(false);
            }, (error: any, resp: any) => {
                // console.log('error =>', error, resp);
                if (resp?.detail?.code === 400) {
                    toast.error(resp?.detail?.message);
                    navigate(URLS.DATASOURCES.LIST);
                    // navigate(URLS.DASHBOARD);
                } else {
                    toast.error("Something went wrong");
                }
                setOnSubmitLoading(false);
            });
        }, 5000);
    };

    // if (isOnSubmitLoading) {
    //     return (<div>
    //         {isOnSubmitLoading && (
    //             <div className="fixed inset-0 bg-opacity-50 flex justify-center items-center z-50">
    //                 <Spinner className="self-center" /> Center the Spinner
    //                 {/* <LoaderSVG size={50} style={{ color: 'blue' }} /> */}

    //             </div>
    //         )}
    //     </div>)
    // }

    useEffect(() => {
        setIsSettingLoading(true);
        setTimeout(() => {
            setIsSettingLoading(false);
        }, 2000);

    }, []);

    useEffect(() => {
        const isLoading = pusherData.some((item: PusherResponse) =>
          item.status === "processing" || item.status === "fetching"
        );
        isAddBtnDisabled.current = isLoading;
      },[pusherData]);

    return (
        <div className="flex min-h-screen">
            <SideMenuBar sideMenuBarClass={'w-64 h-screen w-1/6 bg-white '} />

            <div className="w-full lg:w-5/6 bg-sky-50 min-h-screen">
                <Header />
                <div className="mt-4 sm:mt-5 p-4 sm:p-6 lg:p-8">
                    <h1 className="text-xl font-semibold text-gray-600 mb-2">DataSources</h1>

                    {/* Paragraph */}
                    <p className="text-sm text-gray-600 mb-6">
                        {/* Visualize how pleased and reviewers are. */}
                        Add link to analyze reviews and improve service.
                    </p>

                    {/* Card Component */}

                    <div className="bg-white shadow-lg rounded-2xl p-4 sm:p-6">

                        {(isSettingLoading || isOnSubmitLoading) && (
                            <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                                <Spinner className="self-center z-50" />
                            </div>
                        )}
                        <div className="mb-4 flex flex-wrap items-center gap-2 sm:gap-3">
                            <div className="relative flex flex-wrap items-center gap-1">
                                <button
                                    className={`py-2 px-3 sm:px-4 mr-1 text-sm sm:text-base ${selectedTab === 'third_party' ? 'bg-blue-500 text-white' : 'bg-sky-100 text-gray-800'} rounded-t-lg`}
                                    onClick={() => setSelectedTab('third_party')}
                                >
                                    Third Party Database
                                </button>
                                {selectedTab === 'third_party' && <Icon name="arrow-dropdown" size={40} className="hidden md:block absolute left-[78px] transform -translate-x-1/2 bottom-[-24px] text-blue-500"
                                />}

                                <button
                                    className={`py-2 px-3 sm:px-4 text-sm sm:text-base ${selectedTab === 'internal' ? 'bg-blue-500 text-white' : 'bg-sky-100 text-gray-800'} rounded-t-lg`}
                                    onClick={() => setSelectedTab('internal')}
                                >
                                    Internal Database
                                </button>
                                {selectedTab === 'internal' && <Icon name="arrow-dropdown" size={40} className="hidden md:block absolute left-[239px] transform -translate-x-1/2 bottom-[-24px] text-blue-500" />}
                            </div>

                            <div className="flex items-center gap-2 sm:ml-auto">
                                <span className="text-sm text-gray-600 font-medium">DataSources List</span>
                                <Icon name="list" size={24} className="bg-blue-500 hover:bg-blue-600 text-white text-sm p-3 rounded-full" onClick={() => navigate(URLS.DATASOURCES.LIST)} tooltipRequired={false} />
                            </div>
                        </div>

                        {/* Tab Content */}
                        {selectedTab === 'third_party' && (
                            <ThirdPartyDatabase
                                branchDS={branchDS}
                                setOnSubmitLoading={setOnSubmitLoading}
                                isAddBtnDisabled={isAddBtnDisabled.current}
                            />

                            // COMMENTED THIS PIECE OF CODE AS IT SEEMS TO BE UNECESSARY
                            // <div className="flex flex-col external-database-container bg-sky-50">
                            //     <div className="flex">
                            //         <div className="w-5/6 p-8">
                            //             <ThirdPartyDatabase
                            //                 inputGroups={inputGroups}
                            //                 setInputGroups={setInputGroups}
                            //             // handleSubmit={handleSubmit}  {/* Pass handleSubmit function as prop */}
                            //             />
                            //         </div>
                            //     </div>

                            //     <div className="flex justify-start ml-4 mt-2">
                            //         <button
                            //             className="flex justify-center w-32 ml-4 rounded-sm bg-blue-500 p-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            //             onClick={() => handleSubmit()} // Trigger handleSubmit when the button is clicked
                            //         >
                            //             Submit
                            //         </button>
                            //     </div>
                            // </div>
                        )}

                        {selectedTab === 'internal' && (
                            <InternalDatabase isAddBtnDisabled={isAddBtnDisabled.current}/>
                        )}
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Settings;